import styled from 'styled-components';

export const ContentWrapper = styled.div`
    position: relative;

    z-index: ${({theme}) => theme.layers.baseLayer};
`;